// components
import FirstSection from "../Components/AboutUs/FirstSection";
import SecondSection from "../Components/AboutUs/SecondSection";
import ThirdSection from "../Components/AboutUs/ThirdSection";
import FourthSection from "../Components/AboutUs/FourthSection";

const AboutUs = () => {
  return (
    <section className="about flex-fill">
      <FirstSection />
      <SecondSection />
      <ThirdSection />
      <FourthSection />
    </section>
  );
};

export default AboutUs;
